import Vue from 'vue'
import Vuex from 'vuex'
import * as API from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    leaderboard: [],
    digita: {
      primary: [],
      quarterfinals: [],
      finals: []
    }
  },
  getters:{

  },
  mutations: {
    setLeaderBoard(state, leaderboard) {
      state.leaderboard = leaderboard
    },
    setDigita(state, digita) {
      state.digita = digita
    }
  },
  actions: {
    async getLeaderboard ({commit}) {
      try {
        const { data } = await API.leaderboard()
        // commit('setLeaderBoard', data && data.slice(0, 6))
        commit('setLeaderBoard', data || [])
      } catch(err) {
        console.log(err)
      }
    },
    async getDigitaList({commit}) {
      try {
        const { lb } = await API.getDigitaList()
        commit('setDigita', {
          primary: lb.map(item => {
            item.Score = item.Score.toFixed(5);
            return item;
          })});
      } catch(err) {
        console.log(err)
      }
    }
  }
})